<template>
  <v-dialog v-model="show" max-width="300px">
    <v-card class="pa-4 pt-5">
      <v-layout column align-center justify-center text-center>
        <span class="title"></span>

        <div class="subheading pb-2">
          Promoção aplicada não permite reservas para esta data.
        </div>
      </v-layout>
      <v-layout>
        <v-btn color="error" class="ma-0 white--text" @click="$emit('close')"
          >CANCELAR</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          class="ma-0 white--text"
          @click="$emit('continuar')"
          >CONTINUAR</v-btn
        >
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  async created() {},

  data() {
    return {};
  },

  props: {
    show: Boolean,
  },

  methods: {
    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.sizeTop {
  height: 48px;
}

.vehicleMap {
  position: relative;
  height: 60vh;
}

.content {
  min-height: 100vh;
  position: relative;
}

.titleMap {
  padding-top: 70px;
}

.headline {
  padding-top: 80px;
}

.contentInside {
  min-height: 73vh;
  padding-bottom: 80px;
  position: relative;
}

.imagem {
  width: auto;
  background-color: transparent;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.selectImgIcon {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 70%;
  margin-top: -50px;
}

.steps {
  padding-top: 80px;
}

.footer {
  position: fixed;
  bottom: 56px;
  width: 100%;
}

.choices {
  display: flex;
}

.colorCheckin {
  color: var(--secondary-color) !important;
}

.colorCheckinFundo {
  background-color: var(--secondary-color) !important;
}

.colorCheckoutFundo {
  background-color: var(--orange-color) !important;
}

.colorCheckout {
  color: var(--orange-color) !important;
}

.bottom {
  margin-bottom: 100px;
}

.button {
  margin: 0 auto;
}

.cardRadius {
  border-radius: 4px;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.button-text {
  text-transform: none;
}

.radio {
  display: flex;
  justify-items: center;
  align-content: space-between;
}
.hidden {
  visibility: hidden;
}
</style>
